import { Role } from '@/Enums/Users/Role.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import ShieldCheckIcon from '@/components/Icons/ShieldCheckIcon';
import TvIcon from '@/components/Icons/TvIcon';
import UserIcon from '@/components/Icons/UserIcon';
import { CustomIcon } from '@/types/Icons/Icon.type';
import { Box } from '@mui/material';

interface IAccountLabelProps {
  Icon: CustomIcon;
  label: string;
  className?: string;
}

const AccountLabel = ({ Icon, label, className }: IAccountLabelProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      borderRadius: '4px',
      padding: '7px 8px',
      width: 'fit-content',
      gap: '2px',
      fontWeight: 600,
    }}
    className={className}
  >
    <Icon className='w-[15px] mr-[2px]' />
    <span>{label}</span>
  </Box>
);

const ROLE_LABEL_PROPS = {
  [Role.ADMIN]: { className: 'bg-[#2C6E49] bg-opacity-[.15] text-[#2C6E49]', Icon: ShieldCheckIcon },
  [Role.ORG_ADMIN]: { className: 'bg-[#FF9F38] bg-opacity-[.15] text-[#FF9F38]', Icon: ShieldCheckIcon },
  [Role.WHITELABEL_ADMIN]: { className: 'bg-[#FF9F38] bg-opacity-[.15] text-[#FF9F38]', Icon: ShieldCheckIcon },
  [Role.CLIENT]: { className: 'bg-[#8338EC] bg-opacity-[.15] text-[#8338EC]', Icon: TvIcon },
  [Role.ADVERTISER]: { className: 'bg-[#F95738] bg-opacity-[.15] text-[#F95738]', Icon: UserIcon },
  [Role.AGENCY]: { className: 'bg-[#F72585] bg-opacity-[.15] text-[#F72585]', Icon: UserIcon },
};

interface IProps {
  userRole: IControlOption<string, Role>;
}

const AccoutType = ({ userRole }: IProps) => {
  const { label, value } = userRole || {};
  return <AccountLabel {...ROLE_LABEL_PROPS[value]} label={label} />;
};

export default AccoutType;
